@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  width: 100%;
  padding: 18px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid $grey-10;
  border-radius: 8px;

  .userInfo {
    margin-left: 12px;

    .displayName {
      margin-bottom: 0px;
      @include md-medium;
      color: $grey-90;
    }

    .email {
      margin-bottom: 0px;
      @include sm-regular;
      color: $grey-40;
    }
  }

  .buttonWrapper {
    margin-left: auto;
  }
}
